import moment from 'moment';

import { CountryISOCodes } from 'common/countries';

export const formatDate = (date, format = 'MM-DD-YYYY') => {
  if (!date) {
    return null;
  }

  return moment(date).format(format);
};

export const getDateFormatByCountry = (
  countryIsocode: string,
): { dateFormat: string; placeholder: string } => {
  switch (countryIsocode) {
    case CountryISOCodes.UnitedKingdom:
      return { dateFormat: 'dd-MM-yyyy', placeholder: 'DD-MM-YYYY' };
    case CountryISOCodes.USA:
    case CountryISOCodes.Canada:
    default:
      return { dateFormat: 'MM-dd-yyyy', placeholder: 'MM-DD-YYYY' };
  }
};
